export function enumToArray<T>(enumType: T): { value: string; key: string }[] {
  const keys = Object.keys(enumType).filter((key) => isNaN(Number(key)));
  return keys.map((key) => {
    return {
      key,
      value: (enumType as any)[key],
    };
  });
}
